import { render, staticRenderFns } from "./orderStatus.vue?vue&type=template&id=7afe2b48&scoped=true&"
import script from "./orderStatus.vue?vue&type=script&lang=js&"
export * from "./orderStatus.vue?vue&type=script&lang=js&"
import style0 from "./orderStatus.vue?vue&type=style&index=0&id=7afe2b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afe2b48",
  null
  
)

export default component.exports